import * as Humanize from "humanize-plus";
import moment from "moment-timezone";
import * as React from "react";

const DATE_FORMAT = "YYYY/MM/DD";
const TIME_ONLY_FORMAT = "HH:mm";
const TZ = "Asia/Tokyo";

export const asCommaedInteger = (naturalInteger: number): string => {
    return Humanize.intComma(naturalInteger);
};

export const tsToFormattedTime = (tsString: string): string => {
    return moment(tsString).tz(TZ).format(TIME_ONLY_FORMAT);
};

export const tsToFormattedDate = (tsString: string): string => {
    return moment(tsString).tz(TZ).format(DATE_FORMAT);
};

export const addLeadingZero = (nr: number): string => {
    const _f = nr >= 10 ? `${nr}` : `0${nr}`;
    return _f;
};

export const IntegerLabel: React.FC<{ value: number }> = (props) => (
    <>{Humanize.intComma(props.value)}</>
);
